<template>
    <div class="person-visitors d-flex flex-column align-items-center">
        <app-sub-title text="Visitas de Personas" />
        <app-person-visitors-filters
            v-if="clientId"
            v-model="filters"
            :onFilter="filterEntries"
            :client-id="clientId"
        />
        <div class="alert alert-info" v-if="!data.data || !data.data.length">
            <h4>No hay información</h4>
        </div>

        <div
            class="person-entries-data d-flex flex-column align-items-center"
            v-if="!!data.data && !!data.data.length"
        >
            <a :href="downloadUrl" target="_blank">
                <i class="fa fa-file-excel-o" aria-hidden="true"></i> Exportar
            </a>

            <app-person-visitors-table
                :data="data.data"
                :show-data-consent="showDataConsent"
            />
            <app-paginator
                :current-page="data.current_page"
                :last-page="data.last_page"
                :from="data.from"
                :to="data.to"
                :per-page="data.per_page"
                :total="data.total"
                :onChangePage="onChangePage"
            />
        </div>
    </div>
</template>
<script>
import PersonVisitorsFilters from "../../../AdminClients/PersonVisitors/PersonVisitorsFilters/PersonVisitorsFilters.vue";
import PersonVisitorsTable from "../../../AdminClients/PersonVisitors/PersonVisitorsTable/PersonVisitorsTable.vue";
import Paginator from "../../../UI/Controls/Paginator/Paginator.vue";
import peopleRepository from "../../../../repositories/people.repository";
export default {
    components: {
        appPersonVisitorsFilters: PersonVisitorsFilters,
        appPersonVisitorsTable: PersonVisitorsTable,
        appPaginator: Paginator
    },
    data() {
        return {
            filters: {
                visitorTypeId: "",
                from: "",
                to: "",
                internal: "",
                destinationId: "",
                name: "",
                document: ""
            },
            data: {},
            page: 1
        };
    },

    props: {
        clientId: {
            type: Number,
            default: ""
        },
        showDataConsent: {
            type: Boolean,
            default: false
        }
    },

    watch: {
        clientId(val) {
            this.getPersonEntries();
        }
    },
    computed: {
        downloadUrl() {
            const queryString = Object.keys(this.filters)
                .map(key =>
                    !!this.filters[key] ? `${key}=${this.filters[key]}` : ""
                )
                .filter(item => !!item)
                .join("&");
            // const join = !!queryString?'?':'';
            const url = `/exports/person-entries/export-excel?client=${this.clientId}&${queryString}`;
            return url;
        }
    },
    methods: {
        getPersonEntries() {
            const pr = Object.assign({}, peopleRepository);
            pr.getPersonEntriesByClient(this.clientId, this.page, this.filters)
                .then(data => {
                    this.data = data;
                })
                .catch(error => {
                    toastr.error("Ocurrió un error al consultar los ingresos");
                });
        },
        onChangePage(page) {
            this.page = page;
            this.getPersonEntries();
        },
        filterEntries() {
            this.page = 1;
            this.getPersonEntries();
        }
    },
    created() {
        this.getPersonEntries();
    }
};
</script>
